import { signalStore, withState } from '@ngrx/signals';

import { withEntities } from '@ngrx/signals/entities';
import { withSelectedEntity } from '../../shared/store/selected-entity.feature';
import { Parcours } from '../models/parcours.model';
import { avecMéthodesParcours } from './parcours.methods';
import { avecSélecteursParcours } from './parcours.selectors';
import { initialState, ParcoursState } from './parcours.state';
import { withPagination } from '@shared/store/pagination.feature';

export const ParcoursStore = signalStore(
  { providedIn: 'root' },
  withEntities<Parcours>(),
  withState<ParcoursState>(initialState),
  withSelectedEntity(),
  withPagination<Parcours>(),
  avecSélecteursParcours(),
  avecMéthodesParcours(),
);
